const rp = require('promise-request-retry');

module.exports = (options) => {
  return rp({
    ...options,
    retry: options.retry || 3,
    timeout: options.timeout || 60000,
    accepted: [200, 403, 404, 429],
    delay: 2000,
    factor: 1.4
  })
}
